"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _before = _interopRequireDefault(require("lodash/before"));

var _alloyReactTile = _interopRequireDefault(require("@adsk/alloy-react-tile"));

var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));

var _alloyReactTooltip = _interopRequireDefault(require("@adsk/alloy-react-tooltip"));

var _alloyReactIcon = require("@adsk/alloy-react-icon");

var _alloyReactHelpers = require("@adsk/alloy-react-helpers");

var _string = require("../../util/string");

var _dom = require("../../util/dom");

var _media = require("../../util/media");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const MediaCardWrapper = _styledComponents.default.div`
  position: relative;
  ${props => props.imageType !== _media.IMAGE_TYPES.NORMAL ? `
  &:after {
      content: '';
      border-radius: 4px;
      position: absolute !important;
      left: 0;
      top: 0;
      background: linear-gradient(to bottom left, rgba(0,0,0,0.7), rgba(0, 0, 0, 0) 25%);
    }
  ` : ""}
`;
const StyledImage = _styledComponents.default.img`
  display: ${props => props.hide ? "none" : "inline"};
  height: 100%;
  width: 100%;
  object-fit: cover;
`;
const IconContainer = _styledComponents.default.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${_alloyReactTheme.default.colors.charcoal600};
`;
const ImageTypeMark = _styledComponents.default.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  color: #fff;
`;
const IconsContainer = _styledComponents.default.div`
  position: absolute;
  bottom: 14px;
  right: 8px;
  display: flex;
  color: ${_alloyReactTheme.default.colors.charcoal700};
  background: ${_alloyReactTheme.default.colors.white};
`;
const referenceIcons = [{
  count: "assetsCount",
  tooltip: "ASSET_REFERENCED",
  IconComponent: _alloyReactIcon.FanIcon
}, {
  count: ["formsCount", "formfieldsCount"],
  tooltip: "FORM_REFERENCED",
  IconComponent: _alloyReactIcon.ClipboardIcon
}, {
  count: "issuesCount",
  tooltip: "ISSUE_REFERENCED",
  IconComponent: _alloyReactIcon.CheckmarkCircleIcon,
  ClipboardIcon: _alloyReactIcon.ClipboardIcon,
  SpeechBubbleIcon: _alloyReactIcon.SpeechBubbleIcon,
  SheetsIcon: _alloyReactIcon.SheetsIcon,
  StampIcon: _alloyReactIcon.StampIcon
}, {
  count: "rfisCount",
  tooltip: "RFI_REFERENCED",
  IconComponent: _alloyReactIcon.SpeechBubbleIcon
}, {
  count: "markupsCount",
  tooltip: "SHEET_REFERENCED",
  IconComponent: _alloyReactIcon.SheetsIcon
}, {
  count: "submittalsCount",
  tooltip: "SUBMITTAL_REFERENCED",
  IconComponent: _alloyReactIcon.StampIcon
}];

const ReferenceIcons = ({
  media
}) => {
  const {
    T
  } = (0, _alloyReactHelpers.useLocale)(({
    locale
  }) => require(`../i18n/${locale}.json`));
  const icons = referenceIcons.filter(i => {
    if (Array.isArray(i.count)) {
      return i.count.reduce((accum, key) => media[key] + accum, 0);
    }

    return media[i.count];
  });
  return /*#__PURE__*/_react.default.createElement(IconsContainer, null, icons.map(icon => {
    return /*#__PURE__*/_react.default.createElement(_alloyReactTooltip.default, {
      key: icon.tooltip,
      content: T.translate(icon.tooltip),
      trigger: _alloyReactTooltip.default.TRIGGER_EVENTS.HOVER,
      placement: _alloyReactTooltip.default.PLACEMENTS.TOP
    }, /*#__PURE__*/_react.default.createElement(icon.IconComponent, {
      size: 13,
      style: {
        margin: "0 3px",
        "margin-top": "auto"
      }
    }));
  }));
};

const MediaCard = ({
  media,
  onChange,
  onClick,
  selected,
  renderOverlay
}) => {
  const {
    T
  } = (0, _alloyReactHelpers.useLocale)(({
    locale
  }) => require(`../i18n/${locale}.json`));
  const getImageTypeMark = (0, _react.useCallback)(() => {
    if (media) {
      switch (media.imageType) {
        case _media.IMAGE_TYPES.PHOTOSPHERE:
          return /*#__PURE__*/_react.default.createElement(_alloyReactIcon.Photo360Icon, {
            size: 24
          });

        case _media.IMAGE_TYPES.VIDEO:
          return /*#__PURE__*/_react.default.createElement(_alloyReactIcon.PlayIcon, {
            size: 24
          });

        default:
          return /*#__PURE__*/_react.default.createElement("div", null);
      }
    }

    return /*#__PURE__*/_react.default.createElement("div", null);
  }, [media]);
  const [imageError, setImageError] = (0, _react.useState)(false); // eslint-disable-next-line

  const reload = (0, _react.useCallback)((0, _before.default)(4, () => setTimeout(_dom.reloadImage, 4000)), []);
  return /*#__PURE__*/_react.default.createElement(MediaCardWrapper, {
    imageType: media.imageType,
    "data-qa": "Shared.MediaCard",
    "data-qa-uid": media.uid
  }, media.imageType &&
  /*#__PURE__*/
  // watermark
  _react.default.createElement(ImageTypeMark, null, getImageTypeMark()), /*#__PURE__*/_react.default.createElement(_alloyReactTile.default, {
    image: media.thumbnailUrl,
    title: media.title || T.translate("UNTITLED"),
    subtitle: media.takenOn && (0, _string.getFormattedDate)(media.takenOn),
    renderIcons: () => /*#__PURE__*/_react.default.createElement(ReferenceIcons, {
      media: media
    }),
    renderImage: () => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledImage, {
        hide: imageError,
        src: media.thumbnailUrl,
        alt: media.title,
        onLoad: () => setImageError(false),
        onError: e => {
          setImageError(true);
          reload(e.target);
        }
      }), imageError && /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_alloyReactIcon.PhotoIcon, {
        size: 56
      })));
    },
    onChange: e => onChange && onChange(e),
    onClick: e => {
      e.preventDefault();
      onClick(e);
    },
    selected: selected,
    style: {
      width: "100%",
      "div.checkbox": {
        backgroundColor: selected ? undefined : _alloyReactTheme.default.colors.white
      }
    },
    renderOverlay: renderOverlay
  }));
};

var _default = MediaCard;
exports.default = _default;